import { ToastAlertTypes } from '@genial/components';

export const screenName = 'equity-order-edit';
export const messageError = '--';

export const defaultErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Erro.',
  'Ocorreu um erro ao enviar ordem,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];
